// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".settings-item{display:flex;flex-direction:row;margin-bottom:20px}.settings-item-left{width:80px;text-align:right;color:rgba(0,0,0,0.65);line-height:32px;font-size:14px;font-weight:normal}.settings-item-right{flex:1;padding-left:20px;padding-right:20px}.settings-video-container{width:240px;height:180px;background-color:#000000;margin-top:20px}\n", ""]);
// Exports
module.exports = exports;
